module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn step-container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 offset-md-2"
  }, [(_vm.$route.query.action === 'edit') ? _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_edit')))]) : _c('h2', [_vm._v(_vm._s(_vm.$t('message.doctor_header.title_new')))]), _vm._v(" "), _c('step', {
    attrs: {
      "currentStep": 3,
      "maxStep": 5
    },
    on: {
      "step_clicked": _vm.gotoPage
    }
  }, [_c('div', {
    slot: "1"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.personal_info')))]), _vm._v(" "), _c('div', {
    slot: "2"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.experience')))]), _vm._v(" "), _c('div', {
    slot: "3"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.schedules')))]), _vm._v(" "), _c('div', {
    slot: "4"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.education')))]), _vm._v(" "), _c('div', {
    slot: "5"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_header.other_info')))])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 offset-md-2 step-body"
  }, [_c('h4', {
    staticClass: "step-header"
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.schedule')))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "form-group online-appointment",
    class: {
      'disable': !_vm.$guser.isPremiumAccount()
    },
    on: {
      "click": function($event) {
        _vm.checkFeature()
      }
    }
  }, [_c('label', {
    staticClass: "switch switch-text switch-pill switch-success"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.doctor.appointment_active),
      expression: "doctor.appointment_active"
    }],
    staticClass: "switch-input",
    attrs: {
      "type": "checkbox",
      "disabled": !_vm.$guser.isPremiumAccount()
    },
    domProps: {
      "checked": Array.isArray(_vm.doctor.appointment_active) ? _vm._i(_vm.doctor.appointment_active, null) > -1 : (_vm.doctor.appointment_active)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.doctor.appointment_active,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.doctor.appointment_active = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.doctor.appointment_active = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.doctor.appointment_active = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-label",
    attrs: {
      "data-on": "On",
      "data-off": "Off"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "switch-handle"
  })]), _vm._v(" "), _c('label', {
    staticClass: "switch-name",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.online_appointment_on')) + " "), (!_vm.$guser.isPremiumAccount()) ? _c('i', {
    staticClass: "fa fa-lock menu-lock",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e()])])])]), _vm._v(" "), _vm._l((_vm.doctor.clinics), function(clinic) {
    return _c('div', {
      key: clinic.id,
      staticClass: "row"
    }, [(_vm.shouldView(clinic.id)) ? _c('div', {
      staticClass: "col-12"
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('label', {
      attrs: {
        "for": "name"
      }
    }, [_vm._v(_vm._s(_vm.$t('message.doctor_schedules.select_time_slot_for')) + " "), _c('b', [_vm._v(_vm._s((_vm.$i18n.locale === 'th') ? clinic.name_th : clinic.name_en))])])]), _vm._v(" "), _c('working-schedule', {
      attrs: {
        "schedules": _vm.schedules_by_clinics[clinic.id],
        "doctor_id": _vm.doctor.id,
        "clinic_id": clinic.id,
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "time_slots": _vm.slotData[clinic.id].time_slots,
        "advance_week_option": true
      },
      on: {
        "scheduleChanged": _vm.updateSchedules
      }
    }), _vm._v(" "), _c('working-time-slot', {
      attrs: {
        "time_slots": _vm.slotData[clinic.id].time_slots,
        "clinic_id": clinic.id,
        "doctor_id": _vm.doctor.id
      },
      on: {
        "timeSlotsChanged": _vm.updateTimeSlots
      }
    }), _vm._v(" "), _c('working-booking-per-slot', {
      attrs: {
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "clinic_id": clinic.id,
        "doctor_id": _vm.doctor.id
      },
      on: {
        "bookingPerSlotChanged": _vm.updateBookingPerSlot
      }
    }), _vm._v(" "), _c('working-slot-preview', {
      attrs: {
        "booking_per_slot": _vm.slotData[clinic.id].booking_per_slot,
        "time_slots": _vm.slotData[clinic.id].time_slots
      }
    })], 1) : _vm._e()])
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 form-group"
  }, [_c('button', {
    staticClass: "btn btn-cancel btn-lg",
    on: {
      "click": _vm.back
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.back')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-store btn-lg",
    on: {
      "click": _vm.saveAndContinue
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.save')))]), _vm._v(" "), (_vm.$route.query.action === 'edit') ? _c('button', {
    staticClass: "btn btn-delete btn-right btn-lg",
    on: {
      "click": _vm.deleteDoctor
    }
  }, [_vm._v(_vm._s(_vm.$t('action_message.remove')))]) : _vm._e()])])], 2), _vm._v(" "), _c('sweet-modal', {
    ref: "lockModal",
    attrs: {
      "icon": "info",
      "title": "ฟังชั้นนี้ถูกปิดการใช้งานอยู่",
      "overlay-theme": "dark"
    }
  }, [_c('p', [_vm._v("ฟังชั้นนี้ถูกปิดการใช้งานอยู่ ต้องการปลดล๊อกกรุณากดปุ่ม unlock ด้านล่าง")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-add btn-lg btn-success",
    on: {
      "click": function($event) {
        _vm.gotoPlanPage()
      }
    }
  }, [(!_vm.isActive) ? _c('i', {
    staticClass: "fa fa-key",
    attrs: {
      "aria-hidden": "true"
    }
  }) : _vm._e(), _vm._v(" Unlock")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0727b050"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/doctor/steps/Schedules.vue
// module id = 979
// module chunks = 1